var fi = {};
module['exports'] = fi;
fi.title = "Finnish";
fi.name = require("./name");